/**
 * Thrown when trying to find a Task within
 * the TaskStore but cannot find it
 */
class TaskNotFoundError extends Error {
    constructor(boardId: number, swimlaneId: number, TaskId: number) {
        super(
            `TaskNotFound: { boardId:${boardId}, swimlaneId: ${swimlaneId}, TaskId:${TaskId} }`
        )
        this.name = 'TaskNotFoundError'
    }
}

export default TaskNotFoundError
